import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from "../../../../environments/environment";

@Component({
  selector: 'app-viagens-ocasionais',
  templateUrl: './viagens-ocasionais.component.html',
  standalone: false

})
export class ViagensOcasionaisComponent {

language: string = '';
defaultLanguage: string = environment.defaultLanguage;

constructor(
    private translate: TranslateService,
    private title: Title
) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['viagensOcasionais']
      this.title.setTitle(pageTitle);
    })
  }
}
